export const SET_TODOS = "SET_TODOS"
export const SET_ERROR = "SET_ERROR"
export const CREATE_TODO = "CREATE_TODO"
export const DELETE_TODO = "DELETE_TODO"
export const UPDATE_TODO = "UPDATE_TODO"